import {
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
} from '@material-ui/core'
import { TabPanel } from './TabPanel'
import { SelectFilter } from './SelectFilter'
import { EmailsHistory } from './EmailsHistory'
import TextField from '@mui/material/TextField'
import { IconButton } from '@mui/material'
import { SearchOutlined, ClearOutlined } from '@mui/icons-material'

export const SentEmailsTab = ({
  tabValue,
  tabIndex,
  users,
  setUsers,
  emails,
  classes,
  theme,
  handleChangeEmailPage,
  handleChangeEmailRowsPerPage,
  onlyCSMembersRecipients,
  setOnlyCSMembersRecipients,
  recipientValue,
  setRecipientValue,
  copros,
  coprosLoading,
  coproValue,
  setCoproValue,
}) => {
  return (
    <>
      <TabPanel value={tabValue} index={tabIndex} classes={classes}>
        <form>
          <Grid container justifyContent="flex-start" alignItems="center">
            <Grid item xs={12} sm={3}>
              <SelectFilter
                id="autocomplete-users"
                options={users.rows}
                loading={users.loading}
                loadingText="Chargement en cours..."
                value={users.selected}
                onChange={(_, newValue) => {
                  setUsers({ ...users, selected: newValue })
                }}
                getOptionLabel={(option) => option.email}
                label="Expéditeur"
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <SelectFilter
                id="autocomplete-copros"
                options={copros}
                loading={coprosLoading}
                loadingText="Chargement en cours..."
                value={coproValue}
                onChange={(_, newValue) => {
                  setCoproValue(newValue)
                }}
                getOptionLabel={(option) => option.code}
                label="Copropriété"
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                style={{ width: '80%' }}
                size={'small'}
                placeholder="Filtrer par destinataire"
                inputProps={{ 'aria-label': 'search' }}
                value={recipientValue}
                onChange={(e) => setRecipientValue(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{ paddingRight: '0.625rem' }}
                    >
                      {recipientValue && (
                        <>
                          <IconButton onClick={() => setRecipientValue('')}>
                            <ClearOutlined />
                          </IconButton>
                        </>
                      )}
                      <IconButton disabled={true}>
                        <SearchOutlined />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={onlyCSMembersRecipients}
                  onChange={(event) =>
                    setOnlyCSMembersRecipients(event.target.checked)
                  }
                />
              }
              label="Envoyés aux membres du CS"
            />
          </Grid>
        </form>
      </TabPanel>

      {!emails.loading && (
        <EmailsHistory
          emails={emails}
          classes={classes}
          theme={theme}
          handleChangePage={handleChangeEmailPage}
          handleChangeRowsPerPage={handleChangeEmailRowsPerPage}
        />
      )}
    </>
  )
}
